import React, { useEffect } from "react";
import { useParams } from "react-router";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import Moralis from "moralis";
import { useMoralis } from "react-moralis";
import Web3 from "web3";
import { useState } from "react";
import { Link } from "react-router-dom";
import defaultAvatar from "../images/default-avatar.jpg";

function SinglePost() {
  useEffect(() => {
    getOwnerNfts();
    getFollowers();
    getFollowing();
    getcurrentSubscritpion();
    getUserData();
  }, []);
  const { id } = useParams();
  var myItemsArray = [];
  var followersArray = [];
  // var followingArray = [];
  const [myItems, setMyItems] = useState();
  const [profileImage, setProfileImage] = useState();
  const [profileBackgroundImage, setProfileBackgroundImage] = useState();
  const [numberOfFollowers, setNumberOfFollowers] = useState();
  const [numberOfFollowing, setNumberOfFollowing] = useState();
  const [twitter, setTwitter] = useState();
  const [instagram, setInstagram] = useState();
  const [name, setName] = useState();
  const [bio, setBio] = useState();

  const [followers, setFollowers] = useState();
  const [following, setFollowing] = useState();

  const { user } = useMoralis();
  const contract_address = "0x0c24491c7CadACc878474047c5d7972340D392C3";
  var abi = [
    {
      inputs: [],
      stateMutability: "nonpayable",
      type: "constructor",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "approved",
          type: "address",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "Approval",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "operator",
          type: "address",
        },
        {
          indexed: false,
          internalType: "bool",
          name: "approved",
          type: "bool",
        },
      ],
      name: "ApprovalForAll",
      type: "event",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "approve",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "awardWinner",
      outputs: [],
      stateMutability: "payable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "burn",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "buyNft",
      outputs: [],
      stateMutability: "payable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "closeAuction",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "string",
          name: "uri",
          type: "string",
        },
        {
          internalType: "uint256",
          name: "price",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "saleNumber",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "auctionTime",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "royality",
          type: "uint256",
        },
      ],
      name: "mintToken",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "previousOwner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnershipTransferred",
      type: "event",
    },
    {
      inputs: [],
      name: "pause",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "Paused",
      type: "event",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "bidAmount",
          type: "uint256",
        },
        {
          internalType: "address",
          name: "mmo_address",
          type: "address",
        },
      ],
      name: "placeBid",
      outputs: [],
      stateMutability: "payable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "purchase",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "auctionTimeNeeded",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "minPrice",
          type: "uint256",
        },
      ],
      name: "putOnAuction",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "price",
          type: "uint256",
        },
      ],
      name: "putOnSale",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "removeNft",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "renounceOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "retriveFromSale",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "string",
          name: "uri",
          type: "string",
        },
      ],
      name: "safeMint",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "safeTransferFrom",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          internalType: "bytes",
          name: "_data",
          type: "bytes",
        },
      ],
      name: "safeTransferFrom",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "operator",
          type: "address",
        },
        {
          internalType: "bool",
          name: "approved",
          type: "bool",
        },
      ],
      name: "setApprovalForAll",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "Transfer",
      type: "event",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "transferOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "Unpaused",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "uint256",
          name: "id",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "string",
          name: "uri",
          type: "string",
        },
      ],
      name: "tokenMinted",
      type: "event",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "transferFrom",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "receiver",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
        {
          internalType: "address",
          name: "mmoAddress",
          type: "address",
        },
      ],
      name: "transfermmo",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "unpause",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "price",
          type: "uint256",
        },
      ],
      name: "updatePrice",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
      ],
      name: "balanceOf",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getApproved",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getAuctionWinner",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "string",
          name: "uri",
          type: "string",
        },
      ],
      name: "getIdbyUri",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getMinBidPrice",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getNftCreator",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getNftRoyality",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getNumberOfBids",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getPrice",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getRemainingBidingTime",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getRunnerup",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getRunnerupBid",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getWinningBid",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getWinningBider",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          internalType: "address",
          name: "operator",
          type: "address",
        },
      ],
      name: "isApprovedForAll",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "isNftForSale",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "isNftOnAuction",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "name",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "owner",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "ownerOf",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "paused",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "bytes4",
          name: "interfaceId",
          type: "bytes4",
        },
      ],
      name: "supportsInterface",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "symbol",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "index",
          type: "uint256",
        },
      ],
      name: "tokenByIndex",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "index",
          type: "uint256",
        },
      ],
      name: "tokenOfOwnerByIndex",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "tokenURI",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "totalSupply",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
  ];
  async function getFollowers() {
    const query = new Moralis.Query("Fellowship");
    query.equalTo("fellow_id", id);
    const results = await query.find();
    setNumberOfFollowers(results.length);
    for (let i = 0; i < results.length; i++) {
      const object = results[i];
      followersArray.push(object.get("follower"));
      //console.log(object.id + ' - ' + object.get('follower'));
    }
    setFollowers(followersArray);
  }
  async function getcurrentSubscritpion() {
    const query = new Moralis.Query("Fellowship");
    query.equalTo("fellow_id", id);
    query.equalTo("follower", user.get("ethAddress"));
    const results = await query.find();
    if (results.length > 0) {
      var unfollowBtn = document.getElementById("unfollow_btn");
      var followBtn = document.getElementById("follow_btn");
      unfollowBtn.style.display = "block";
      followBtn.style.display = "none";
    } else if (results.length == 0) {
      unfollowBtn.style.display = "none";
      followBtn.style.display = "block";
    }
    console.log(results);
  }
  async function getFollowing() {
    const query = new Moralis.Query("Fellowship");
    query.equalTo("fellower", id);
    const results = await query.find();
    setNumberOfFollowing(results.length);
    for (let i = 0; i < results.length; i++) {
      const object = results[i];
      followersArray.push(object.get("fellow_id"));
      //console.log(object.id + ' - ' + object.get('follower'));
    }
    setFollowers(followersArray);
  }

  async function getOwnerNfts() {
    const myItemsOptions = {
      chain: "bsc",
      address: id,
      token_address: contract_address,
    };
    const myItemsData = await Moralis.Web3API.account.getNFTsForContract(
      myItemsOptions
    );
    for (var i = 0; i < myItemsData.result.length; i++) {
      const contract_address = "0x0c24491c7CadACc878474047c5d7972340D392C3";
      const myItemsMetadataoptions = {
        address: contract_address,
        token_id: myItemsData.result[i].token_id,
        chain: "bsc",
      };
      const tokenIdMetadata = await Moralis.Web3API.token.getTokenIdMetadata(
        myItemsMetadataoptions
      );
      // console.log(tokenIdMetadata.token_id);
      //console.log(tokenIdMetadata.token_uri);
      //console.log(tokenIdMetadata);

      const contract_abi = abi;
      const web3 = new Web3(window.ethereum);
      const contract = new web3.eth.Contract(contract_abi, contract_address);
      const tokenURI = await contract.methods
        .tokenURI(tokenIdMetadata.token_id)
        .call();
      var obj;
      await fetch(tokenURI)
        .then((res) => res.json())
        .then((data) => (obj = data));
      //console.log("this is parsed jason: ");

      const nftMetadataBundle = {
        nftUri: obj.image,
        nftName: obj.nftName,
        nftCat: obj.category,
        nftRoyality: obj.royalty,
        nftId: tokenIdMetadata.token_id,
      };
      myItemsArray.push(nftMetadataBundle);
    }
    setMyItems(myItemsArray);
  }

  async function addFollower() {
    const Fellowship = Moralis.Object.extend("Fellowship");
    const userAddress = user.get("ethAddress");
    const fellow = new Fellowship();
    fellow.set("fellow_id", id);
    fellow.set("follower", userAddress);

    await fellow.save().then(
      (monster) => {
        // Execute any logic that should take place after the object is saved.
        console.log("New object created with objectId: " + monster.id);

        var element = document.getElementById("unfollow_btn");
        element.classList.toggle("show");
      },
      (error) => {
        console.log("An Erro Occured: " + error.message);
      }
    );
  }

  async function getUserData() {
    /*+++++++++++++++++++++
       GET USER PROFILE DATA
      +++++++++++++++++++++++*/
    const query = new Moralis.Query("Profiles");
    const userEthAddress = id;
    const stringEathAddress = userEthAddress.toString();
    const upAddress = stringEathAddress.toUpperCase();
    //console.log("eath address to get: " + upAddress )
    query.startsWith("userAddress", upAddress);
    const results = await query.find();
    /* console.log(results) */

    if (results.length != 0) {
      const object = results[0];
      var ownerNameFromMoralis = object.get("name");
      var proImageFromMoralis = object.get("pro_image");
      var twitterFromMorialis = object.get("twitter");
      var instagramFromMorialis = object.get("instagram");
      var BgFromMorialis = object.get("bgImage");
      var bioFromMorialis = object.get("bio");
      setProfileImage(proImageFromMoralis);
      setProfileBackgroundImage(BgFromMorialis);
      setName(ownerNameFromMoralis);
      setTwitter(twitterFromMorialis);
      setInstagram(instagramFromMorialis);
      setBio(bioFromMorialis);
      console.log(
        "name: " +
          ownerNameFromMoralis +
          "  Image: " +
          proImageFromMoralis +
          " twitter: " +
          twitterFromMorialis +
          " Insa: " +
          instagramFromMorialis +
          " BG: " +
          BgFromMorialis
      );
    } else {
      var defaultOwnerName = id;
      var defualtProImage = defaultAvatar;
    }
  }

  return (
    <>
      <div className="container-fluid profile_background">
        {profileBackgroundImage && (
          <img src={profileBackgroundImage} alt="Profile_Background_Image" />
        )}
      </div>
      <div className="profile_pic_div">
        <span>
          {!profileImage && (
            <img className="profile_img" src={defaultAvatar}></img>
          )}
          {profileImage && (
            <div>
              <img className="profile_img" src={profileImage}></img>,
              <h4 className="text-center profile_onwer_name">{name}</h4>
            </div>
          )}
        </span>
      </div>

      <div className="user_address">
        <span className="profile_address">{id}</span>
        <button id="follow_btn" onClick={addFollower} className="follow-btn">
          Follow
        </button>
        <button id="unfollow_btn" className="unfollow-btn">
          <i className="fa fa-check"></i>
        </button>
      </div>

      {/*------------- Stats------------------ */}

      <div className="row stats_outer_div">
        <div className="col-md-3"></div>

        <div className="col-md-3 stats_div_followers ">
          <div>
            <h4 className="stats_number text-center">{numberOfFollowers}</h4>
            <h4> Followers</h4>
          </div>
        </div>

        <div className="col-md-3 stats_div_following ">
          <div>
            <h4 className="stats_number text-center">{numberOfFollowing}</h4>
            <h4>Following</h4>
          </div>
        </div>

        <div className="col-md-3"></div>
      </div>

      {/*Social & Details*/}
      <div className="Profile_social_div">
        <Link to={{ pathname: instagram }} target={"_blank"}>
          <i className="fa fa-instagram social_icons"></i>
        </Link>

        <Link to={{ pathname: twitter }} target={"_blank"}>
          <i className="fa fa-twitter social_icons"></i>
        </Link>
      </div>
      <div className="profile_detail">
        <p>{bio}</p>
      </div>

      {/*-------------------End of Stats------------------------*/}

      <div className="container author_tabs">
        <Tabs
          defaultActiveKey="onsale"
          id="uncontrolled-tab-example"
          className="mb-3"
        >
          <Tab eventKey="onsale" title="OnSale">
            <div className="container grand_parent_div">
              <div className="row">
                {myItems &&
                  myItems.map((curElem) => {
                    return (
                      <div className="col-md-3 card-col">
                        <Link to={`/nftdetails/${curElem.nftId}`}>
                          <div class="card explore-card">
                            <div className="card-body explore-card-body">
                              <img
                                src={curElem.nftUri}
                                width="200px"
                                height="300px"
                              />
                              <h5 className="card-text title">
                                {curElem.nftName}
                              </h5>
                              <h4 className="card-text card-link">
                                Category: {curElem.nftCat}
                              </h4>
                              <h4 className="card-text card-link">
                                Royality: {curElem.nftRoyality}%
                              </h4>
                            </div>
                          </div>
                        </Link>
                      </div>
                    );
                  })}
              </div>
            </div>
          </Tab>
          <Tab eventKey="collectables" title="Collectables">
            <div className="container grand_parent_div">
              <div className="row">
                {myItems &&
                  myItems.map((curElem) => {
                    return (
                      <div className="col-md-3 card-col">
                        <Link to={`/nftdetails/${curElem.nftId}`}>
                          <div class="card explore-card">
                            <div className="card-body explore-card-body">
                              <img
                                src={curElem.nftUri}
                                width="200px"
                                height="300px"
                              />
                              <h5 className="card-text title">
                                {curElem.nftName}
                              </h5>
                              <h4 className="card-text card-link">
                                Category: {curElem.nftCat}
                              </h4>
                              <h4 className="card-text card-link">
                                Royality: {curElem.nftRoyality}%
                              </h4>
                            </div>
                          </div>
                        </Link>
                      </div>
                    );
                  })}
              </div>
            </div>
          </Tab>
        </Tabs>
      </div>
    </>
  );
}

export default SinglePost;
